﻿import ApiService from 'services/ApiService'

export const ReportingService = {
    getWidgets() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/reporting/widgets`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    getWidget(widgetId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/reporting/widgets/${widgetId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    saveWidgetOrder(widgetOrder)
    {
        return new Promise((resolve, reject) => {
            ApiService.put('/reporting/widgets/selection', widgetOrder)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        })
    }
}